module.exports = __webpack_public_path__ + "img/pdf.d501a846.svg";